import React from 'react';
import { Clock } from 'lucide-react';
import { useReport } from '../hooks/useReport';

/**
 * Current in-flight (PENDING) work. DELIBERATELY OUTSIDE the report population
 * (which is terminal-state only) — rendered as a visually distinct panel, never
 * mixed into any scoped total. It ignores the report filters by design.
 */
const InFlightPanel = () => {
  const { data } = useReport('/reports/mis/pipeline/in-flight');
  const byLevel = data?.byLevel || {};
  const levels = ['LEVEL_1', 'LEVEL_2', 'FINAL'];

  return (
    <div className="rounded-md border border-dashed border-dash-warning/60 bg-dash-warning/5 p-4">
      <div className="mb-2 flex items-center gap-2">
        <Clock size={15} className="text-dash-warning" />
        <h3 className="text-sm font-semibold text-dash-foreground">Current In-Flight</h3>
        <span className="rounded bg-dash-warning/15 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-dash-warning">
          Not in report totals
        </span>
      </div>
      <p className="mb-3 text-[11px] text-dash-muted-foreground">
        Pending vendors still moving through the pipeline — outside the terminal-state population above.
      </p>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
        {levels.map((l) => (
          <div key={l} className="rounded border border-dash-border bg-dash-card px-3 py-2">
            <p className="text-[10px] uppercase tracking-wide text-dash-muted-foreground">{l.replace('_', ' ')}</p>
            <p className="text-lg font-semibold tabular-nums text-dash-foreground">{byLevel[l] ?? 0}</p>
          </div>
        ))}
        <div className="rounded border border-dash-border bg-dash-card px-3 py-2">
          <p className="text-[10px] uppercase tracking-wide text-dash-muted-foreground">Pending vendors</p>
          <p className="text-lg font-semibold tabular-nums text-dash-foreground">{data?.pendingVendors ?? 0}</p>
        </div>
      </div>
    </div>
  );
};

export default InFlightPanel;
